import store from 'dashboard/store';

/**
 * Router hook patient-id-guard.js
 *
 * @namespace patient-id-guard
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/router/hooks/patient-id-guard.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 */

/**
 * Resets store when navigating to another patient's route
 * @function
 * @memberof patient-id-guard
*/
export default (to, from, next) => {
    const isPatientRoute = to.matched.some((match) => match.path === '/patient/:patientId');
    const currentPatientId = from.params?.patientId;
    const newPatientId = to.params?.patientId;

    if (isPatientRoute && currentPatientId !== undefined && newPatientId !== undefined && currentPatientId !== newPatientId) {
        resetStore(newPatientId);
    }

    if (store.getters['patientSummary/isResetRequired']) {
        store.dispatch('patientSummary/reset');
    }

    if (store.getters['patientList/isResetRequired']) {
        store.dispatch('patientList/reset');
    }

    next();
}

 /**
 * @function resetStore
 * @memberof patient-id-guard
 * @param {string} patientId ID of a patient
 */
export async function resetStore(patientId) {
    // console.log('reset store for ' + patientId);
    store.dispatch('dss/reset');
    store.dispatch('encounter/reset');
    store.dispatch('expertTool/reset');
    store.dispatch('followupSession/reset');
    store.dispatch('newPatient/reset');
    store.dispatch('patientList/reset');
    store.dispatch('patientSummary/reset');

    await Promise.all([
        store.dispatch('patientSummary/get', patientId, {root: true}),
        store.dispatch('alerts/reset', null, {root: true}),
        // store.dispatch('alerts/getRecent', patientId, {root: true}),
        store.dispatch('enabledModules/getEnabledModules'),
    ]);

    const patient = {
        text: store.getters['patientSummary/searchText'],
        patientId: store.getters['patientSummary/id'],
    };

    // Set select correct
    if (patient) {
        store.dispatch('patientList/selectPatient', patient);
    }
}
